import { render, staticRenderFns } from "./CalendarWeekdays.vue?vue&type=template&id=f0358652&"
import script from "./CalendarWeekdays.vue?vue&type=script&lang=js&"
export * from "./CalendarWeekdays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports